<template>
  <div class="cardBox">
    <div class="card">
      <div class="content">
        <div class="back">
          <div class="back-content">
            <svg stroke="#ffffff" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 1024 1024" height="50px" width="50px" fill="#ffffff">
              <g stroke-width="0" id="SVGRepo_bgCarrier"></g>
              <g stroke-linejoin="round" stroke-linecap="round" id="SVGRepo_tracerCarrier"></g>
              <g id="SVGRepo_iconCarrier">
                <path
                  d="M226.56 316.586667q0-24.32-35.84-21.76H170.666667v42.666666h28.16c19.2 3.84 28.16-5.546667 27.733333-20.906666z m-32 341.333333h204.8v-21.333333h-204.8z m0 170.666667h204.8v-26.453334h-204.8z m0-54.613334h204.8v-24.32h-204.8z m0-58.026666h204.8v-24.32h-204.8z m534.186667-120.32H768v-19.626667h-37.12z m0 54.613333H768v-20.906667h-37.12z m87.466666-2.56H853.333333v-18.346667h-36.266666z m0-52.053333H853.333333v-19.626667h-36.266666z m-597.333333-363.52C220.586667 217.173333 213.333333 213.333333 192.853333 213.333333H170.666667v38.4h26.88q22.613333-0.426667 22.613333-20.906666z m362.666667 462.506666h26.88v-42.666666h-26.88z m0 85.333334l26.88-7.253334v-40.106666h-26.88z m0-167.68h26.88v-47.36h-26.88zM853.333333 0H170.666667a170.666667 170.666667 0 0 0-170.666667 170.666667v682.666666a170.666667 170.666667 0 0 0 170.666667 170.666667h682.666666a170.666667 170.666667 0 0 0 170.666667-170.666667V170.666667a170.666667 170.666667 0 0 0-170.666667-170.666667z m-232.106666 303.786667q-76.8-21.76-76.8-76.8c0-48.64 29.866667-73.813333 85.333333-75.52a78.08 78.08 0 0 1 85.333333 74.24h-61.44a17.066667 17.066667 0 0 0-9.813333-15.36 22.186667 22.186667 0 0 0-16.213333-5.12c-14.506667 0-21.333333 4.693333-21.333334 14.08s12.8 16.64 38.826667 24.32q75.52 21.76 75.52 74.24c0 52.053333-32.426667 78.506667-93.013333 79.36a85.333333 85.333333 0 0 1-88.746667-76.8h62.72a35.413333 35.413333 0 0 0 11.093333 19.2 32 32 0 0 0 18.346667 5.12q28.16 0 28.16-16.64c0-9.386667-12.8-17.493333-37.973333-24.32z m268.373333 228.693333V682.666667h-198.826667v-149.333334h70.4v-32.426666h58.026667v32.426666zM104.106667 157.866667h95.146666c55.04 0 81.92 18.773333 81.493334 58.88A64.853333 64.853333 0 0 1 256 267.946667a51.626667 51.626667 0 0 1 33.28 53.76c0 47.786667-28.16 71.68-85.333333 71.68H104.106667z m386.986666 714.666666H104.106667v-42.666666h42.666666v-237.653334h123.306667v-27.306666H113.493333v-42.666667h156.586667v-23.04h51.626667v22.613333h158.72v42.666667H323.84v26.453333h124.16v237.226667h42.666667zM414.72 397.226667Q314.453333 393.386667 311.04 273.066667q5.12-115.2 103.68-121.6 98.56 5.12 104.96 122.88-4.266667 117.76-104.96 122.88z m270.933333 406.613333l-21.76 5.973333v60.586667h-48.64v-51.2l-80.64 15.786667-11.093333-42.666667 11.093333-5.12v-222.293333h-11.093333v-39.68h154.453333v39.68h-14.08V768l21.76-7.253333z m226.56-60.586667h-134.826666l-5.546667 16.213334h113.493333v80.64s-6.826667 28.16-49.493333 30.293333h-85.333333l-9.386667-35.413333s0-11.093333 16.213333-11.093334h64.853334s16.213333 0 10.666666-21.333333h-114.773333s-11.093333 0-5.546667-21.76l10.666667-37.546667h-48.64v-42.666666h237.653333z m-85.333333-346.026666a82.346667 82.346667 0 0 1-88.746667-76.8h62.72A34.986667 34.986667 0 0 0 810.666667 341.333333a32 32 0 0 0 18.346666 5.12q28.16 0 28.16-16.64c0-9.386667-12.373333-17.493333-37.973333-24.32q-76.8-21.76-76.8-76.8 2.56-72.96 85.333333-75.52a78.08 78.08 0 0 1 85.333334 74.24H853.333333a16.64 16.64 0 0 0-9.386666-15.36 23.04 23.04 0 0 0-16.213334-5.12q-21.76 0-21.76 14.08c0 8.533333 12.8 16.64 38.826667 24.32 50.346667 14.506667 75.946667 39.253333 75.946667 74.24-2.56 50.346667-33.28 76.8-93.866667 77.653334zM414.72 209.066667c-24.746667 0-37.546667 22.613333-38.826667 65.28S389.973333 341.333333 414.72 341.333333s39.253333-23.466667 40.106667-67.84-14.933333-64.426667-40.106667-64.426666z">
                </path>
              </g>
            </svg>
            <strong>BOSS已支持</strong>
          </div>
        </div>
        <div class="front">
          <div class="img">
            <div class="circle">
            </div>
            <div class="circle" id="right">
            </div>
            <div class="circle" id="bottom">
            </div>
          </div>
          <div class="front-content">
            <div class="title">BOSS功能一览</div>
            <div class="desc">
              <div>职位自动刷新</div>
              <div>自动保存简历</div>
              <div>人选简历查重</div>
              <div>一键自动复聊</div>
              <div><span style="color: #3b82f6; font-weight: bold;">AI</span>精准打招呼</div>
              <div><span style="color: #3b82f6; font-weight: bold;">AI</span>自动回复</div>
            </div>
            <div class="btn">
              <el-button @click="handGreet" size="small" plain round>立即使用</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    handGreet() {
      this.$router.push({
        path: '/bsgreet'
      })
    },

  }
}
</script>

<style lang="scss" scoped>
* {
  box-sizing: border-box;
}

.card {
  overflow: visible;
  width: 240px;
  height: 299px;
  box-sizing: border-box;
  user-select: none;

  .content {
    width: 100%;
    height: 100%;
    transform-style: preserve-3d;
    transition: transform 300ms;
    box-shadow: 0px 0px 10px 1px #252d3a;
    border-radius: 5px;

    .front,
    .back {
      background-color: #252d3a;
      position: absolute;
      width: 100%;
      height: 100%;
      backface-visibility: hidden;
      -webkit-backface-visibility: hidden;
      border-radius: 5px;
      overflow: hidden;
    }

    .back {
      width: 100%;
      height: 100%;
      justify-content: center;
      display: flex;
      align-items: center;
      overflow: hidden;
    }

    .back::before {
      position: absolute;
      content: ' ';
      display: block;
      width: 160px;
      height: 160%;
      background: linear-gradient(90deg, transparent, #45A2FF, #45A2FF, #45A2FF, #45A2FF, transparent);
      animation: rotation_481 5000ms infinite linear;
    }

    .back-content {
      position: absolute;
      width: 99%;
      height: 99%;
      background-color: #1e2834;
      border-radius: 5px;
      color: white;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      gap: 30px;
    }

    .front {
      transform: rotateY(180deg);
      color: white;

      .img {
        position: absolute;
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: center;

        .circle {
          width: 90px;
          height: 90px;
          border-radius: 50%;
          background-color: #ffbb66;
          position: relative;
          filter: blur(15px);
          animation: floating 2600ms infinite linear;
        }

        #bottom {
          background-color: #ff8866;
          left: 50px;
          top: 0px;
          width: 150px;
          height: 150px;
          animation-delay: -800ms;
        }

        #right {
          background-color: #ff2233;
          left: 160px;
          top: -80px;
          width: 30px;
          height: 30px;
          animation-delay: -1800ms;
        }
      }

      .front-content {
        position: absolute;
        width: 100%;
        height: 100%;
        padding: 10px;

        .title {
          letter-spacing: 2px;
          background-color: #00000055;
          font-size: 14px;
          padding: 5px 10px;
          border-radius: 10px;
          backdrop-filter: blur(2px);
          width: fit-content;
        }

        .desc {
          letter-spacing: 2px;
          margin-top: 10px;
          padding: 10px;
          border-radius: 10px;
          background-color: #00000055;
          font-size: 14px;
          line-height: 2.1;
        }

        .btn {
          margin-top: 10px;
          text-align: center;
          cursor: pointer;
        }
      }
    }
  }
}

.card:hover .content {
  transform: rotateY(180deg);
}


@keyframes rotation_481 {
  0% {
    transform: rotateZ(0deg);
  }

  0% {
    transform: rotateZ(360deg);
  }
}

@keyframes floating {
  0% {
    transform: translateY(0px);
  }

  50% {
    transform: translateY(10px);
  }

  100% {
    transform: translateY(0px);
  }
}
</style>